'use client'

import { useState, useContext } from 'react'
import { Button } from 'antd'
import { ShortDisclaimerAlert } from '@/src/components'
import { AmplitudeContext } from '@/src/contexts'
import { trackPhysicianEvents } from '@/src/lib'
import { Physician } from '@/src/interfaces'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export const PhoneButton = ({
  text,
  physician,
  position,
  color,
  variant,
  isProfileCard,
  className,
}: {
  text: string
  physician: Physician
  position?: number | string
  color: 'primary' | 'default'
  variant: 'solid' | 'outlined'
  isProfileCard?: boolean
  className?: string
}) => {
  const [showPhone, setShowPhone] = useState(false)
  const { trackAmplitudeEvent } = useContext(AmplitudeContext)

  const handleClick = () => {
    if (!showPhone) {
      setShowPhone(true)

      // Amplitude - Track when phone number is revealed
      trackPhysicianEvents.phoneButtonClicked(trackAmplitudeEvent)({
        ...physician,
        position: position ?? 'Position Not Available',
      })
    } else {
      window.location.href = `tel:${physician.phone}`
    }
  }

  return (
    <>
      <Button
        color={showPhone ? 'primary' : color}
        variant={showPhone ? 'solid' : variant}
        block={false}
        onClick={handleClick}
        className={className}
      >
        <FontAwesomeIcon icon='phone' />
        {showPhone ? physician.phone : text}
      </Button>
      {showPhone && isProfileCard && <ShortDisclaimerAlert />}
    </>
  )
}
